import React from 'react';

const APP_STORE_URL = 'https://apps.apple.com/us/app/1medicine/id6477750419';
const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=co.redcanvas.onemed&hl=en_US&pli=1';

const CTASection: React.FC = () => {
  return (
    <section id="mobile" className="section-shell scroll-mt-20">
      <div className="site-container">
        <div className="relative overflow-hidden rounded-[2rem] bg-[#0b1811] px-6 py-10 text-white shadow-[0_35px_90px_rgba(12,38,23,0.22)] sm:px-10 sm:py-14 lg:min-h-[38rem] lg:px-16">
          <div className="pointer-events-none absolute inset-0 mobile-showcase-grid" aria-hidden="true" />
          <div className="pointer-events-none absolute -left-32 top-1/2 h-80 w-80 -translate-y-1/2 rounded-full bg-emerald-500/20 blur-3xl" aria-hidden="true" />
          <div className="pointer-events-none absolute -right-24 -top-24 h-96 w-96 rounded-full bg-lime-300/10 blur-3xl" aria-hidden="true" />

          <div className="relative grid items-center gap-14 lg:grid-cols-[1.05fr_0.95fr]">
            <div className="max-w-xl">
              <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.06] px-3 py-1.5 text-xs font-semibold text-emerald-200 backdrop-blur">
                <span className="h-1.5 w-1.5 rounded-full bg-emerald-400 shadow-[0_0_12px_rgba(52,211,153,0.8)]" />
                1MEDICINE for mobile
              </div>
              <h2 className="text-4xl font-semibold leading-[1.02] tracking-[-0.05em] text-white sm:text-5xl">
                Your medical library, ready when you are.
              </h2>
              <p className="mt-6 max-w-lg text-base leading-7 text-slate-300 sm:text-lg">
                Review structured resources, find the detail you need, and keep your
                learning moving—whether you are at a desk or between moments in your day.
              </p>

              <ul className="mt-8 grid gap-3 text-sm text-slate-200 sm:grid-cols-2">
                {['Focused mobile reading', 'Fast access to your library', 'Search and save resources', 'Available on iOS and Android'].map((item) => (
                  <li key={item} className="flex items-center gap-2.5">
                    <span className="flex h-5 w-5 items-center justify-center rounded-full bg-emerald-400/15 text-emerald-300">
                      <svg aria-hidden="true" className="h-3 w-3" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2.2">
                        <path strokeLinecap="round" strokeLinejoin="round" d="m5 10 3 3 7-7" />
                      </svg>
                    </span>
                    {item}
                  </li>
                ))}
              </ul>

              <div className="mt-9 flex flex-col gap-3 sm:flex-row">
                <a
                  href={APP_STORE_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Download 1MEDICINE on the App Store"
                  className="store-button"
                >
                  <svg aria-hidden="true" className="h-8 w-8" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M17.05 12.54c-.03-2.69 2.2-3.99 2.3-4.05a4.94 4.94 0 0 0-3.89-2.11c-1.64-.17-3.23.98-4.07.98-.86 0-2.15-.96-3.54-.93a5.17 5.17 0 0 0-4.35 2.65c-1.89 3.27-.48 8.08 1.33 10.72.9 1.28 1.95 2.71 3.34 2.66 1.36-.06 1.87-.86 3.51-.86 1.63 0 2.11.86 3.53.83 1.46-.02 2.38-1.29 3.24-2.58a10.72 10.72 0 0 0 1.48-3.01 4.65 4.65 0 0 1-2.88-4.3ZM14.39 4.64A4.72 4.72 0 0 0 15.47 1.2a4.8 4.8 0 0 0-3.12 1.64 4.5 4.5 0 0 0-1.11 3.31 3.97 3.97 0 0 0 3.15-1.51Z" />
                  </svg>
                  <span>
                    <span className="block text-[10px] font-medium uppercase leading-none tracking-[0.08em] text-slate-400">Download on the</span>
                    <span className="mt-1 block text-lg font-semibold leading-none">App Store</span>
                  </span>
                </a>
                <a
                  href={GOOGLE_PLAY_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Get 1MEDICINE on Google Play"
                  className="store-button"
                >
                  <svg aria-hidden="true" className="h-8 w-8" viewBox="0 0 32 36">
                    <path fill="#00d6ff" d="M1.2 1.7A3 3 0 0 0 .5 3.8v28.4c0 .8.2 1.5.7 2.1l15.7-16.2L1.2 1.7Z" />
                    <path fill="#ffce00" d="m22.2 12.7-5.3 5.4 5.5 5.6 6.7-3.8c2-1.1 2-2.9 0-4l-6.9-3.2Z" />
                    <path fill="#00f076" d="M1.2 1.7 22.2 12.7l-5.3 5.4L1.2 1.7Z" />
                    <path fill="#ff3a44" d="m1.2 34.3 21.2-10.6-5.5-5.6L1.2 34.3Z" />
                  </svg>
                  <span>
                    <span className="block text-[10px] font-medium uppercase leading-none tracking-[0.08em] text-slate-400">Get it on</span>
                    <span className="mt-1 block text-lg font-semibold leading-none">Google Play</span>
                  </span>
                </a>
              </div>
              <a
                href="https://1medicine.app"
                target="_blank"
                rel="noopener noreferrer"
                className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-emerald-300 transition-colors hover:text-emerald-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-emerald-400"
              >
                Prefer a larger screen? Open the web app
                <span aria-hidden="true">↗</span>
              </a>
            </div>

            <div className="relative mx-auto w-full max-w-[21rem] lg:translate-y-16">
              <div className="absolute -inset-8 rounded-full bg-emerald-400/15 blur-3xl" aria-hidden="true" />
              <div className="phone-shell relative mx-auto">
                <div className="phone-speaker" aria-hidden="true" />
                <div className="phone-screen">
                  <img
                    src="/assets/mobile_screen.png"
                    alt="1MEDICINE mobile app displaying a structured clinical resource"
                    className="h-full w-full object-cover object-top"
                    loading="lazy"
                  />
                </div>
              </div>
              <div className="absolute -left-10 bottom-20 hidden rounded-2xl border border-white/10 bg-white/[0.09] px-4 py-3 shadow-2xl backdrop-blur-xl sm:block">
                <p className="text-[10px] font-semibold uppercase tracking-[0.14em] text-emerald-300">Built for focus</p>
                <p className="mt-1 text-sm font-semibold text-white">Clear. Structured. Portable.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
